import { z } from "zod";
import { EventStatusSchema } from "@/api/types/event";
import { InvoiceKindSchema, InvoiceStatusSchema } from "@/api/types/invoice";

/**
 * Client portal (U4b) — Zod schemas for the U4a backend contract
 * (app/api/portal.py). Distinct from the staff-facing Event/Invoice/Contract
 * schemas in @/api/types: the portal payloads are trimmed, read-only-shaped
 * views scoped to a single event by portal token, not the full staff
 * records — so they get their own types here rather than reusing
 * EventSchema/InvoiceSchema, even though the status/kind enums are shared.
 */

export const PortalEventSchema = z.object({
  id: z.string(),
  event_date: z.string(),
  status: EventStatusSchema,
  package_name: z.string().nullable(),
});
export type PortalEvent = z.infer<typeof PortalEventSchema>;

export const PortalInvoiceSchema = z.object({
  id: z.string(),
  kind: InvoiceKindSchema,
  number: z.string(),
  total_cents: z.number(),
  paid_cents: z.number(),
  amount_due_cents: z.number(),
  status: InvoiceStatusSchema,
  due_date: z.string().nullable(),
});
export type PortalInvoice = z.infer<typeof PortalInvoiceSchema>;

export const PortalContractSchema = z.object({
  id: z.string(),
  status: z.string(),
  signed: z.boolean(),
  signer_name: z.string().nullable(),
  signed_at: z.string().nullable(),
});
export type PortalContract = z.infer<typeof PortalContractSchema>;

export const PortalMeSchema = z.object({
  event: PortalEventSchema,
  invoices: z.array(PortalInvoiceSchema),
  contract: PortalContractSchema.nullable(),
});
export type PortalMe = z.infer<typeof PortalMeSchema>;

export const PortalCheckoutSchema = z.object({
  url: z.string(),
});

export interface PortalSignInput {
  signer_name: string;
  signer_email?: string;
  consent: boolean;
}
